// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"218":"766b3c94","927":"a2e5db88"}[chunkId] + ".chunk.js";
};